import gsap from 'gsap'

import {
  getScrollTriggerOptions,
  linesRevealAnimation,
  type SharedAnimation
} from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const editorialVerticalTextRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const title = selector('[data-motion-title]')[0]
  const text = selector('[data-motion-text]')[0]

  const animations: SharedAnimation[] = []
  const revealTimelines: gsap.core.Timeline[] = []

    ;[title, text].forEach((el, i) => {
      if (!el) return

      const scrollOpts = getScrollTriggerOptions(el, reverse)
      const revealTimeline = gsap.timeline({
        ...scrollOpts,
        delay: delay + i * 0.1
      })

      const anim = linesRevealAnimation(el, true)
      revealTimeline.add(anim.timeline, 0)
      animations.push(anim)
      revealTimelines.push(revealTimeline)
    })

  return () => {
    revealTimelines.forEach((tl) => {
      tl.scrollTrigger?.kill()
      tl.kill()
    })
    animations.forEach((anim) => anim.revert())
  }
}
